import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { chatApi } from '../api/chat';

const KEYS = {
  list:   (page: number) => ['chat', 'list', page] as const,
  detail: (id: number)   => ['chat', 'detail', id] as const,
};

export function useChatConversations(page = 1) {
  return useQuery({
    queryKey: KEYS.list(page),
    queryFn:  () => chatApi.list(page),
    staleTime: 15_000,
  });
}

export function useChatConversation(id: number) {
  return useQuery({
    queryKey: KEYS.detail(id),
    queryFn:  () => chatApi.find(id),
    enabled:  id > 0,
    refetchInterval: false,
  });
}

export function useCreateConversation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (title?: string) => chatApi.create(title),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chat', 'list'] });
    },
  });
}

export function useSendMessage(conversationId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (message: string) => chatApi.sendMessage(conversationId, message),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEYS.detail(conversationId) });
      queryClient.invalidateQueries({ queryKey: ['chat', 'list'] });
    },
  });
}

export function useDeleteConversation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => chatApi.destroy(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chat'] });
    },
  });
}
